import React, { HTMLAttributes } from "react";
import "./SlideHeaderButton.scss";

interface IProps extends HTMLAttributes<HTMLButtonElement> {
    variant: 'close' | 'next' | 'previous'
}

export function SlideHeaderButton({variant, children, ...buttonProps}: IProps) {
    return (
        <div className={`slide-header-button-wrapper variant-${variant}`}>
            <button {...buttonProps}>
                {['close', 'previous'].includes(variant) ? (<>
                    <svg className={"icon"} data-name="Component 2 – 109" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                        <circle id="Ellipse_9" data-name="Ellipse 9" cx="25" cy="25" r="25" fill="#fff" opacity="0"/>
                        <g id="Group_49" data-name="Group 49" transform="translate(-299.683 1017.778) rotate(135)">
                            <rect id="Rectangle_271" data-name="Rectangle 271" width="16" height="4" rx="2" transform="translate(-941 475)" fill="#208fcb"/>
                            <rect id="Rectangle_272" data-name="Rectangle 272" width="4" height="16" rx="2" transform="translate(-929 463)" fill="#208fcb"/>
                        </g>
                    </svg>
                </>) : null}
                <span>{children}</span>
                {variant === 'next' ? (<>
                    <svg className={"icon"} data-name="Component 2 – 108" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                        <circle id="Ellipse_9" data-name="Ellipse 9" cx="25" cy="25" r="25" fill="#fff" opacity="0"/>
                        <g id="Group_49" data-name="Group 49" transform="translate(349.683 -967.778) rotate(-45)">
                            <rect id="Rectangle_271" data-name="Rectangle 271" width="16" height="4" rx="2" transform="translate(-941 475)" fill="#208fcb"/>
                            <rect id="Rectangle_272" data-name="Rectangle 272" width="4" height="16" rx="2" transform="translate(-929 463)" fill="#208fcb"/>
                        </g>
                    </svg>

                </>) : null}
            </button>
        </div>
    )
}
